// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"c3673ab9","618":"cb67abff"}[chunkId] + ".chunk.css";
};